<template>
  <div>
    <!-- <vs-row>
      <vs-col>
        <h3 class="headerText ml-3 mb-3">Report a Problem</h3>
      </vs-col>
    </vs-row> -->
    <!-- <pre>{{ basicSettings }}</pre> -->
    <br />
    <vs-row vs-w="12" style="justify-content: center; align-items: center">
      <vs-col vs-lg="8" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <vs-row class="mt-3">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <img
                data-v-12dff204=""
                src="/img/sentenance_logo.2adbbb74.png"
                alt="Dashboard"
                width="250px"
              />
            </vs-col>
          </vs-row>

          <vs-row class="mb-4 mt-4">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <!-- <div class="input-box container-fluid">
                <br /> -->

              <h3 style="color: #111111; font-size: 1.4rem">
                Report a Problem
              </h3>
              <!-- </div> -->
            </vs-col>
          </vs-row>

          <!-- <pre>{{ optionsHeader }}</pre> -->
          <div v-for="(item, index) in basicSettings" :key="index">
            <vs-col
              v-if="
                [1, 2].includes(item.value) &&
                !['Description of the Problem', 'Attach a picture'].includes(
                  item.text
                )
              "
              class="vscolMain"
              vs-type="flex"
              vs-align="center"
              vs-w="6"
            >
              <div
                v-if="['Priority'].includes(item.text)"
                class="input-box container-fluid"
              >
                <span
                  style="
                    font-size: 0.8rem;
                    padding-left: 5px;
                    color: rgba(0, 0, 0, 0.7);
                  "
                  >{{ item.text }}</span
                >

                <vs-select v-model="item.response" class="selectVS mt-1">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in optionsPriority"
                  />
                </vs-select>
              </div>
              <div v-else class="input-box container-fluid">
                <span
                  style="
                    font-size: 0.8rem;
                    padding-left: 5px;
                    color: rgba(0, 0, 0, 0.7);
                  "
                  >{{ item.text }}</span
                >

                <vs-input class="selectVS mt-1" v-model="item.response" />
              </div>
            </vs-col>
          </div>

          <!-- Custom Field -->
          <div v-for="(item, index) in basicSettings.customField" :key="index">
            <!-- v-if="[1].includes(item.value)" -->
            <vs-col
              v-if="[1, 2].includes(item.value)"
              class="vscolMain"
              vs-type="flex"
              vs-align="center"
              vs-w="6"
            >
              <div class="input-box container-fluid">
                <span
                  style="
                    font-size: 0.8rem;
                    padding-left: 5px;
                    color: rgba(0, 0, 0, 0.7);
                  "
                  >Custom Field {{ index + 1 }}</span
                >
                <!-- {{ item.name }} -->
                <vs-input class="selectVS mt-1" v-model="item.response" />
              </div>
            </vs-col>
          </div>
          <div
            v-for="(item, index) in basicSettings.customDropdown"
            :key="index"
          >
            <!-- v-if="[1].includes(item.value)" -->
            <vs-col
              v-if="[1].includes(item.value)"
              class="vscolMain"
              vs-type="flex"
              vs-align="center"
              vs-w="6"
            >
              <div class="input-box container-fluid">
                <span
                  style="
                    font-size: 0.8rem;
                    padding-left: 5px;
                    color: rgba(0, 0, 0, 0.7);
                  "
                  >{{ item.name }}</span
                >

                <vs-select class="selectVS mt-1" v-model="item.response">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.value"
                    v-for="(item, index) in item.options"
                  />
                </vs-select>
              </div>
            </vs-col>
          </div>
          <!-- <vs-row class="mb-4 mt-3"> -->
          <!-- <vs-col vs-type="flex" class="mb-2 mt-2" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-select class="selectVS mt-1" label="Type" v-model="select4">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options4"
                />
              </vs-select>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-select
                class="selectVS mt-1"
                label="Location"
                v-model="select4"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options4"
                />
              </vs-select>
            </div>
          </vs-col> -->
          <!-- </vs-row> -->
          <!-- <vs-row class="mb-4 mt-3"> -->
          <!-- <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-select
                class="selectVS mt-1"
                label="Location"
                v-model="select4"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options4"
                />
              </vs-select>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-select
                class="selectVS mt-1"
                label="Location"
                v-model="select4"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options4"
                />
              </vs-select>
            </div>
          </vs-col> -->
          <!-- </vs-row> -->
          <!-- <vs-row class="mb-4 mt-3"> -->
          <!-- <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-input
                class="selectVS mt-1"
                label="Phone Number"
                placeholder="Your Phone Number"
                v-model="select1"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <vs-input
                class="selectVS mt-1"
                label="Email"
                placeholder="Your Email"
                v-model="select4"
              />
            </div>
          </vs-col> -->
          <!-- </vs-row> -->
          <!-- <vs-row class="mb-4"> -->
          <vs-col
            v-if="[1].includes(basicSettings.description.value)"
            class="vscolMain"
            vs-type="flex"
            vs-align="center"
            vs-w="12"
          >
            <div class="input-box container-fluid">
              <span
                style="
                  font-size: 0.8rem;
                  padding-left: 5px;
                  color: rgba(0, 0, 0, 0.7);
                "
                >Please enter what you would like to say</span
              >
              <vs-textarea
                class="widthTextArea mt-2"
                v-model="basicSettings.description.response"
              />
            </div>
          </vs-col>
          <!-- </vs-row> -->

          <vs-row
            v-if="[1].includes(basicSettings.attachPicture.value)"
            class="mb-4"
          >
            <vs-col vs-type="flex" vs-align="center" vs-w="12">
              <div class="input-box container-fluid">
                <vs-row vs-align="center">
                  <span
                    class="mr-2"
                    style="font-size: 0.8rem; color: rgba(0, 0, 0, 0.7)"
                    >Upload File</span
                  >
                  <vs-button
                    style="border-radius: 20px"
                    icon="cloud_upload"
                    v-if="showUpload == false"
                    color="primary"
                    @click="showUpload = !showUpload"
                    type="filled"
                    >Select File</vs-button
                  ></vs-row
                >
                <UploadImages
                  v-if="showUpload == true"
                  class="mt-2"
                  style="padding: 5px"
                  @changed="handleImages"
                />
              </div>
            </vs-col>
          </vs-row>
          <br />
          <vs-row style="padding: 0px" class="mb-4">
            <vs-col vs-type="flex" vs-align="center" vs-w="12">
              <div class="input-box container-fluid">
                <vs-row vs-align="center">
                  <span class="detailFoot"
                    >Check Work Requests You've Submitted</span
                  >
                  <vs-spacer />
                  <vs-button
                    @click="submit(basicSettings)"
                    style="border-radius: 20px; width: 80px"
                    color="primary"
                    type="filled"
                    >Submit</vs-button
                  >
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card style="border-radius: 20px">
          <vs-row>
            <h3 class="headerText">Report a Problem</h3>
            <br />
            <vs-row vs-w="8" class="mt-4 mb-2">
              <vs-col
                vs-type="flex"
                vs-align="center"
                vs-sm="4"
                vs-xs="4"
                vs-lg="4"
              >
                <div class="input-box container-fluid">
                  <vs-select
                    class="selectVS mt-1"
                    label="Type"
                    v-model="select4"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in options4"
                    />
                  </vs-select>
                </div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-align="center"
                vs-sm="4"
                vs-xs="4"
                vs-lg="4"
              >
                <div class="input-box container-fluid">
                  <vs-select
                    class="selectVS mt-1"
                    label="Location"
                    v-model="select4"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in options4"
                    />
                  </vs-select>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-2 mb-4">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <div class="input-box container-fluid">
                  <vs-input
                    class="selectVS mt-1"
                    label="Name"
                    placeholder="Your Name"
                    v-model="select1"
                  />
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <div class="input-box container-fluid">
                  <vs-input
                    class="selectVS mt-1"
                    label="Email"
                    placeholder="Your Email"
                    v-model="select4"
                  />
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-2 mb-4">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <div class="input-box container-fluid">
                  <vs-input
                    class="selectVS mt-1"
                    label="Phone Number"
                    placeholder="Your Phone Number"
                    v-model="select1"
                  />
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <div class="input-box container-fluid">
                  <vs-input
                    class="selectVS mt-1"
                    label="Email"
                    placeholder="Your Email"
                    v-model="select4"
                  />
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mb-4">
              <vs-col vs-type="flex" vs-align="center" vs-w="6">
                <div class="input-box container-fluid">
                  <span class="detail"
                    >Please enter what you would like to say</span
                  >
                  <textarea
                    v-model="select1Normal"
                    style="
                      resize: none;
                      margin-top: 5px;
                      width: 100%;
                      border-radius: 6px;
                      border: 1px solid rgba(0, 0, 0, 0.2);
                      overflow-y: auto;
                      padding: 10px;
                      font-size: 0.75rem;
                      height: 150px;
                    "
                  ></textarea>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mb-4 input-box container-fluid">
              <vs-col vs-type="flex" w="12">
                <span class="mt-3 detail">Upload file :</span>
                <vs-button
                  style="border-radius: 20px"
                  icon="cloud_upload"
                  v-if="showUpload == false"
                  color="primary"
                  size="small"
                  @click="showUpload = !showUpload"
                  type="filled"
                  >Select File</vs-button
                >
                <UploadImages
                  v-if="showUpload == true"
                  class="mt-2"
                  style="padding: 5px"
                  @changed="handleImages"
                />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row> -->
  </div>
</template>

<script>
import UploadImages from "vue-upload-drop-images";
export default {
  components: {
    UploadImages,
  },
  props: ["basicSettings"],
  data: () => ({
    title: {},
    optionsPriority: [
      { text: "1 - Low Priority", value: 1 },
      { text: "2 - Medium Priority", value: 2 },
      { text: "3 - High Priority", value: 3 },
    ],
    // basicSettings: {
    //   assignedTo: { text: "Assigned To", value: 1 },
    //   titleWR: { text: "Title of the Work Request", value: 1 },
    //   priority: { text: "Priority", value: 1 },
    //   nameRequester: { text: "Name", value: 0 },
    //   phoneRequester: { text: "Phone Number", value: 0 },
    //   emailRequester: { text: "Email", value: 0 },
    //   location: { text: "Where or what is having the problem?", value: 0 },
    //   compleDate: { text: "Requested Completion Date", value: 0 },
    //   attachPicture: { text: "Attach a picture", value: 0 },
    //   titleAdvan: { text: "IT", value: 0 },
    //   description: { text: "Description of the Problem", value: 0 },
    //   customField: [
    //     { name: "", value: "" },
    //     // { name: "", value: "" },
    //     // { name: "", value: "" },
    //   ],
    //   customDropdown: [
    //     { name: "", value: "", options: [{ value: "" }] },
    //     // { name: "", value: "", options: [] },
    //     // { name: "", value: "", options: [] },
    //   ],
    //   customTag: "",
    //   logo: [],
    // },
    showUpload: false,
    select1Normal: "",
    basicSettings: [],
    select1: "",
    select2: "",
    uuid : "",
    select3: "",
    select4: "",
    options1: [
      { text: "IT", value: 0 },
      { text: "Blade Runner", value: 2 },
      { text: "Thor Ragnarok", value: 3 },
    ],
    options3: [
      { text: "Red", value: 1 },
      { text: "Green", value: 2 },
      { text: "Blue", value: 3 },
      { text: "Purple", value: 4 },
    ],
    options5: [
      { text: "Square", value: 1 },
      { text: "Rectangle", value: 1 },
      { text: "Rombo", value: 1 },
      { text: "Romboid", value: 1 },
      { text: "Trapeze", value: 2 },
      { text: "Triangle", value: 2 },
      { text: "Polygon", value: 3 },
    ],
    optionsHeader: [
      { text: "Assigned To", value: 1 },
      { text: "Title of the Work Request", value: 2 },
      { text: "Priority", value: 3 },
      { text: "Name", value: 4 },
      { text: "Phone Number", value: 5 },
      { text: "Email", value: 6 },
      { text: "Where or what is having the problem?", value: 7 },
    ],
  }),
  methods: {
    submit(item) {
      console.log(item);
      this.$API.post(`workrequest/${this.uuid}`, {data: item}).then((result) => {
        console.log(result);
        this.basicSettings = result.data;
      });
    },
  },
  mounted() {
    // this.basicSettings = [];
    // this.basicSettings = this.$session.get("basicSettings");
    // this.$API.get("workrequest/customform/752c4e264c78").then((result) => {
    //    this.basicSettings = result.data;
    // });
    // this.hideSideBar();
    this.basicSettings = [];
    this.basicSettings = this.$session.get("basicSettings");
    this.uuid = this.$route.params.uuid;
    this.$API.get(`workrequest/customform/${this.uuid}`).then((result) => {
      this.basicSettings = result.data;
    });
  },
};
</script>

<style scoped>
.vscolMain {
  margin: 10px 0;
}
.detailFoot {
  font-size: 0.8rem;
  font-weight: 100;
  color: rgba(var(--vs-primary), 1);
  cursor: pointer;
}
.selectVS {
  width: 95%;
  font-size: 0.8rem;
}
@media (min-width: 576px) {
  .vs-row > .vs-col {
    padding: 0;
  }
}
</style>